export default __webpack_public_path__ + "static/media/Senid Karađuz.3346b156.jpg";